import moment from "moment";
import { convertCurrency } from "./ShareUtils";
import { Toast } from 'antd-mobile';

export function _formatFormField(data) {
    if (!data) {
        return undefined;
    }
    if (!data.inputValue) {
        data.inputValue = [];
    }
    if (data.multipleValue) {
        data.multipleValue = JSON.parse(data.multipleValue);
    } else {
        data.multipleValue = [];
    }
    if (data.moreSetting) {
        data.moreSetting = JSON.parse(data.moreSetting);
    }
    if (data.fieldType === 'CUSTOMIZE_RadioButton' && data.multipleValue) {
        for (var i = 0; i < data.multipleValue.length; i++) {
            if (data.multipleValue[i]['children']) {
                data['isCascadeDropDown'] = true;
                break;
            }
        }
    }
    data.isReadOnly = data.isReadOnly === 'true';
    data.isRequired = data.isRequired === 'true';
    data.isCapital = data.isCapital === 'true';
    data.isVisible = true;
    return data;
}

export function _updateFormFieldDefaultValue(data, formFields) {
    var defaultValue = '';
    for (let index = 0; index < formFields.length; index++) {
        const element = formFields[index];
        if (element.fieldId === data.defaultValue.substring(2, data.defaultValue.length - 1)) {
            if (element.inputValue && element.inputValue.length > 0 && element.inputValue[0]) {
                defaultValue = element.inputValue[0];
            }
            break;
        }
        if (element.fieldType === 'ChildField' || element.fieldType === 'FORMREFCustomerField') {
            for (let subIndex = 0; subIndex < element.childFormFields.length; subIndex++) {
                const subElement = element.childFormFields[subIndex];
                if (subElement.fieldType === 'ChildField') {
                    for (let sonIndex = 0; sonIndex < subElement.childFormFields.length; sonIndex++) {
                        const soneElement = subElement.childFormFields[sonIndex];
                        if (soneElement.fieldId === data.defaultValue.substring(2, data.defaultValue.length - 1)) {
                            if (soneElement.inputValue && soneElement.inputValue.length > 0 && soneElement.inputValue[0]) {
                                defaultValue = soneElement.inputValue[0];
                            }
                            break;
                        }
                    }
                    if (defaultValue) {
                        break;
                    }
                } else {
                    if (subElement.fieldId === data.defaultValue.substring(2, data.defaultValue.length - 1)) {
                        if (subElement.inputValue && subElement.inputValue.length > 0 && subElement.inputValue[0]) {
                            defaultValue = subElement.inputValue[0];
                        }
                        break;
                    }
                }
            }
        }
        if (defaultValue) {
            break;
        }
    }
    if (defaultValue) {
        data.inputValue = [defaultValue];
    } else {
        data.inputValue = [''];
        if (data.fieldType === 'NumberField') {
            data.inputValue = [0];
        }
    }

    return data;
}

export function _getFormatEquation(equation) {
    if (!equation) {
        return undefined;
    }
    equation = equation.replace(/\$\{\*\}/g, '*');
    equation = equation.replace(/\$\{\+\}/g, '+');
    equation = equation.replace(/\$\{\-\}/g, '-');
    equation = equation.replace(/\$\{\/\}/g, '/');
    equation = equation.replace(/\$\{\(\}/g, '(');
    equation = equation.replace(/\$\{\)\}/g, ')');

    return equation;
}

export function _getEquationFieldValue(data, formFields) {
    var value = 0;
    if (data.moreSetting && data.moreSetting.equation) {
        try {
            var equation = _getFormatEquation(data.moreSetting.equation);
            formFields.map(item => {
                var fieldValue = 0;
                if (item.inputValue && item.inputValue.length > 0 && item.inputValue[0]) {
                    fieldValue = item.inputValue[0];
                }
                if (equation.indexOf('${' + item.fieldId + '}') >= 0) {
                    equation = equation.replace(new RegExp("\\${" + item.fieldId + "\}", 'g'), '(' + parseFloat(fieldValue) + ')');
                } else if (item.fieldType === 'FORMREFCustomerField' || item.fieldType === 'ChildField') {
                    item.childFormFields.map(subItem => {
                        if (equation.indexOf('${' + subItem.fieldId + '}') >= 0) {
                            fieldValue = 0;
                            if (data.parentId || item.fieldType === 'FORMREFCustomerField') {
                                fieldValue = subItem.inputValue[0];
                            } else {
                                for (var i = 0; i < item.inputValue.length; i++) {
                                    if (item.inputValue[i][subItem.fieldId]) {
                                        var tmpValue = parseFloat(item.inputValue[i][subItem.fieldId]);
                                        if (!isNaN(tmpValue)) {
                                            fieldValue += tmpValue;
                                        }
                                    }
                                }
                            }

                            equation = equation.replace(new RegExp("\\${" + subItem.fieldId + '\}', 'g'), '(' + parseFloat(fieldValue) + ')');
                        } else if (subItem.fieldType === 'ChildField') {
                            subItem.childFormFields.map(sonItem => {
                                if (equation.indexOf('${' + sonItem.fieldId + '}') >= 0) {
                                    fieldValue = sonItem.inputValue[0];
                                    if (!isNaN(parseFloat(fieldValue))) {
                                        equation = equation.replace(new RegExp("\\${" + sonItem.fieldId + '\}', 'g'), '(' + parseFloat(fieldValue) + ')');
                                    }
                                }
                            })
                        }
                    })
                }
            })
            if (equation.indexOf('${field') < 0) {
                if (equation.indexOf('/(0)') > 0) {
                    equation = equation.replace(/\/\(0\)/g, '/(1)');
                }
                if (equation.indexOf('*(0)') > 0) {
                    equation = equation.replace(/\*\(0\)/g, '*(1)');
                }
                value = eval(equation);
                if (isNaN(value)) {
                    value = undefined;
                }
            }
        } catch (err) {
            value = undefined;
        }
        if (value != undefined) {
            if (data.moreSetting && undefined != data.moreSetting.decimalPoint && data.moreSetting.decimalPoint != -1) {
                value = value.toFixed(data.moreSetting.decimalPoint);
            }

            if (value == '0.00' || value == '0.0') {
                value = 0;
            }
        } else {
            value = 0;
        }
    }

    return value;
}

export function _getStatisticsValue(data, formField) {
    var value = 0;
    if (data.moreSetting && data.moreSetting.statistics &&
        data.moreSetting.statistics.values && data.moreSetting.statistics.values.length >= 2) {
        var statisticsType = data.moreSetting.statistics.type;
        if (formField.fieldId == data.moreSetting.statistics.values[0]) {
            if (formField.fieldType === 'FORMREFCustomerField') {
                var inputValue = [];
                if (formField.inputValue) {
                    for (let index = 0; index < formField.inputValue.length; index++) {
                        inputValue.push(formField.inputValue[index].fieldList);
                    }
                }
                value = _statisticsValue(inputValue, statisticsType, data);
            } else {
                value = _statisticsValue(formField.inputValue, statisticsType, data);
            }
        }
    }
    if (data.moreSetting && undefined != data.moreSetting.decimalPoint && data.moreSetting.decimalPoint != -1) {
        value = value.toFixed(data.moreSetting.decimalPoint);
    }
    if (value == '0.00' || value == '0.0') {
        value = 0;
    }

    return value;
}

export function _statisticsValue(inputValue, statisticsType, data) {
    var tmpValue = 0;
    var totalValue = 0;
    var value = 0;
    if (inputValue) {
        for (var j = 0; j < inputValue.length; j++) {
            var fieldValue = inputValue[j][data.moreSetting.statistics.values[1]];
            if (fieldValue && fieldValue.length > 0) {
                tmpValue = fieldValue[0];
            }
            totalValue += parseFloat(tmpValue);
            switch (statisticsType) {
                case 1:
                    value += parseFloat(tmpValue);
                    break;
                case 2:
                    if (j === 0) {
                        value = parseFloat(tmpValue)
                    } else {
                        if (value < parseFloat(tmpValue)) {
                            value = parseFloat(tmpValue)
                        }
                    }
                    break;
                case 3:
                    if (j === 0) {
                        value = parseFloat(tmpValue)
                    } else {
                        if (value > parseFloat(tmpValue)) {
                            value = parseFloat(tmpValue)
                        }
                    }
                    break;
                case 4:
                    break;
                default:
                    break;
            }
        }
        if (statisticsType == 4) {
            value = totalValue / inputValue.length;
        }
    }

    return value;
}

export function _getDownloadPath(url, name) {
    return '/file/download?fileUrl=' + encodeURIComponent(url) + '&fileName=' + encodeURIComponent(name);
}

export function _randomString(len) {
    len = len || 32;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

export function _checkChildFormInputValue(dataObj, formFields) {
    for (var i = 0; i < formFields.length; i++) {
        let itemFormField = formFields[i];
        if (itemFormField.isVisible && itemFormField.isRequired) {
            if (!itemFormField.inputValue || itemFormField.inputValue.length === 0 || itemFormField.inputValue[0].length === 0) {
                Toast.offline('请填写' + itemFormField.fieldTitle, 2);
                var element
                if (i > 1) {
                    for (var j = 1; j < i; j++) {
                        element = document.getElementById(formFields[i - j].fieldId);
                        if (element) {
                            break;
                        }
                    }
                } else {
                    element = document.getElementById(formFields[0].fieldId);
                }
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
                return undefined;
            }
        }
        if (!itemFormField.isVisible) {
            itemFormField.inputValue = [""];
        }
        dataObj[itemFormField.fieldId] = itemFormField.inputValue;
        if (itemFormField.fieldType === 'TimeField') {
            if (itemFormField.inputValue && itemFormField.inputValue.length > 0) {
                dataObj[itemFormField.fieldId] = [moment(itemFormField.inputValue[0]).format('HH:mm')];
            } else {
                dataObj[itemFormField.fieldId] = '';
            }
        } else if (itemFormField.fieldType === 'DateField') {
            if (itemFormField.inputValue && itemFormField.inputValue.length > 0) {
                dataObj[itemFormField.fieldId] = [moment(itemFormField.inputValue[0]).format('YYYY-MM-DD')];
            } else {
                dataObj[itemFormField.fieldId] = '';
            }
        } else if (itemFormField.fieldType === 'DateTimeField') {
            if (itemFormField.inputValue && itemFormField.inputValue.length > 0) {
                dataObj[itemFormField.fieldId] = [moment(itemFormField.inputValue[0]).format('YYYY-MM-DD HH:mm')];
            } else {
                dataObj[itemFormField.fieldId] = '';
            }
        } else if (itemFormField.fieldType === 'StaffField') {
            if (itemFormField.inputValue) {
                dataObj[itemFormField.fieldId] = [];
                for (var j = 0; j < itemFormField.inputValue.length; j++) {
                    var item = { userid: itemFormField.inputValue[j].userid, name: itemFormField.inputValue[j].name };
                    dataObj[itemFormField.fieldId].splice(dataObj[itemFormField.fieldId].length, 0, item);
                }
            }
        }
        if (itemFormField.fieldType === 'RadioButton' ||
            itemFormField.fieldType === 'CheckBox' ||
            itemFormField.fieldType === 'DropDown') {
            if (!dataObj['multipleValue']) {
                dataObj['multipleValue'] = {};
            }
            dataObj['multipleValue'][itemFormField.fieldId] = itemFormField.multipleValue;
        }
    }

    if (dataObj["fieldList"]) {
        var fieldList = {};
        for (let key in dataObj) {
            if (key == 'fieldList' || key == 'id' || key == 'example' || key == 'checked' || key == 'formDataId' || key == 'instanceTitle') {
                continue;
            }
            fieldList[key] = dataObj[key];
        }
        dataObj["fieldList"] = fieldList;
    }

    return dataObj;
}


export function _formatTDText(text, formField, record) {
    if (!formField || !text) {
        return "";
    }
    var fieldType = formField.fieldType;
    if (text && fieldType === "TextArea") {
        var inputValue = record[formField.fieldId];
        if (inputValue.length > 1) {
            text = inputValue[0];
        }
    } else if (text && (fieldType === "EquationField" || fieldType === "StatisticsField" || fieldType === "NumberField")) {
        if (formField.moreSetting && undefined != formField.moreSetting.decimalPoint && formField.moreSetting.decimalPoint != -1) {
            text = parseFloat(text + "").toFixed(formField.moreSetting.decimalPoint);
        }
        if (formField.isCapital && formField.isCapital === 'true') {
            text = text + "<br>大写金额（人民币）：" + convertCurrency(text);
        }
    } else if (text && fieldType === "CascadeDropDown") {
        var textTmp = "";
        for (var i = 0; i < text.length; i++) {
            textTmp += text[i];
            if (i < text.length - 1) {
                textTmp += "/";
            }
        }
        text = textTmp;
    } else if (text && fieldType === "DateField") {
        try {
            text = moment(text[0]).format('YYYY-MM-DD');
        } catch (err) {

        }
    } else if (text && fieldType === "TimeField") {
        try {
            text = moment(text[0]).format('HH:mm');
        } catch (err) {

        }
    } else if (text && fieldType === "DateTimeField") {
        try {
            text = moment(text[0]).format('YYYY-MM-DD HH:mm');
        } catch (err) {

        }
    } else if (text && fieldType === "StaffField") {
        try {
            text = text[0].name;
        } catch (err) {

        }
    } else if (text && fieldType === "ChildField") {
        text = '子表单，点击查看详细内容';
    }

    return text;
}

export function _onNumberChange(value, data) {
    if (data.moreSetting && undefined != data.moreSetting.decimalPoint && data.moreSetting.decimalPoint != -1) {
        if (value == undefined) {
            value = 0
        }
        value = value.toString();
        if (value === "") {
            data.inputValue = [];
        } else {
            if (value.indexOf(".") == -1) {
                data.inputValue = [parseInt(value)];
            } else {
                var parts = value.split(".");
                var IntegerNum = parts[0];
                var DecimalNum = parts[1].substr(0, data.moreSetting.decimalPoint < parts[1].length ? data.moreSetting.decimalPoint : parts[1].length);
                data.inputValue = [parseFloat(IntegerNum + "." + DecimalNum)];
            }
        }
    } else {
        data.inputValue = [value];
    }
    return data;
}

//flag==1填单页面；flag==2详情页面；
export function _setFormFieldVisibleStatus(formFieldList, nodePermissions, flag, formStatus, isTransactor) {
    var visibleFormFields = [];
    var visibleFormFieldsTag = [];
    for (var i = 0; i < formFieldList.length; i++) {
        var multipleValue = formFieldList[i].multipleValue;
        if (multipleValue) {
            for (var j = 0; j < multipleValue.length; j++) {
                if (multipleValue[j].showFormFields && multipleValue[j].showFormFields.length > 0) {
                    var showFormFields = multipleValue[j].showFormFields;
                    for (var k = 0; k < showFormFields.length; k++) {
                        var name = i + "baishayan" + multipleValue[j].name;
                        if (visibleFormFieldsTag.indexOf(showFormFields[k]) >= 0) {
                            var value = [];
                            var index = 0;
                            for (var m = 0; m < visibleFormFields.length; m++) {
                                if (visibleFormFields[m].key === showFormFields[k]) {
                                    value = visibleFormFields[m].value;
                                    index = m;
                                    break;
                                }
                            }
                            var isHas = false;
                            for (let l = 0; l < value.length; l++) {
                                if (value[l] === name) {
                                    isHas = true;
                                    break;
                                }
                            }
                            if (!isHas) {
                                value.splice(value.length, 0, name);
                                visibleFormFields.splice(index, 1, { key: showFormFields[k], value: value });
                            }
                        } else {
                            visibleFormFieldsTag.splice(visibleFormFieldsTag.length, 0, showFormFields[k]);
                            visibleFormFields.splice(visibleFormFields.length, 0, { key: showFormFields[k], value: [name] });
                        }
                    }
                }
            }
        }
    }

    for (var i = 0; i < formFieldList.length; i++) {
        formFieldList[i].isVisible = true;
        for (var j = 0; j < visibleFormFields.length; j++) {
            if (visibleFormFields[j].key === formFieldList[i].fieldId) {
                var value = visibleFormFields[j].value;
                formFieldList[i].isVisible = false;
                for (var k = 0; k < value.length; k++) {
                    var index = value[k].split("baishayan")[0];
                    var name = value[k].split("baishayan")[1];
                    if (formFieldList[index].inputValue.indexOf(name) >= 0 && formFieldList[index].isVisible) {
                        formFieldList[i].isVisible = true;
                        break;
                    }
                }
                break;
            }
        }
        if (flag == 2) {
            if (formStatus === 1) {
                if (formFieldList[i].moreSetting && formFieldList[i].moreSetting.notPrint == true) {
                    formFieldList[i].isVisible = false;
                }
            }
            if (formFieldList[i].isVisible) {
                if (formFieldList[i].moreSetting && formFieldList[i].moreSetting.notShow == true) {
                    formFieldList[i].isVisible = false;
                }
            }
        }
    }

    for (var i = 0; i < formFieldList.length; i++) {
        if (undefined != formFieldList[i].isVisible && !formFieldList[i].isVisible) {
            continue;
        }
        formFieldList[i].isEditable = true;
        if (flag == 2) {
            formFieldList[i].isEditable = false;
        }
        var fieldId = formFieldList[i].fieldId;
        if (nodePermissions[fieldId]) {
            if (flag == 2) {
                if (isTransactor) {
                    formFieldList[i].isEditable = nodePermissions[fieldId].editable;
                }
            } else {
                formFieldList[i].isEditable = nodePermissions[fieldId].editable;
            }
        }
        if (formFieldList[i].fieldType === 'ChildField' || formFieldList[i].fieldType === "FORMREFCustomerField") {
            if (formFieldList[i].childFormFields.length === 0) {
                formFieldList[i].isVisible = false;
                continue;
            }
            for (var j = 0; j < formFieldList[i].childFormFields.length; j++) {
                formFieldList[i].childFormFields[j].isEditable = true;
                if (flag == 2) {
                    formFieldList[i].childFormFields[j].isEditable = false;
                }
                if (undefined != formFieldList[i].childFormFields[j].isVisible && !formFieldList[i].childFormFields[j].isVisible) {
                    continue;
                }
                var subFieldId = formFieldList[i].childFormFields[j].fieldId;
                if (nodePermissions[subFieldId]) {
                    if (flag == 2) {
                        if (isTransactor) {
                            formFieldList[i].childFormFields[j].isEditable = nodePermissions[subFieldId].editable;
                        }
                    } else {
                        formFieldList[i].childFormFields[j].isEditable = nodePermissions[subFieldId].editable;
                    }
                }
                if (formFieldList[i].childFormFields[j].fieldType == 'ChildField') {
                    if (formFieldList[i].childFormFields[j].childFormFields.length === 0) {
                        formFieldList[i].childFormFields[j].isVisible = false;
                        continue;
                    }
                    for (var k = 0; k < formFieldList[i].childFormFields[j].childFormFields.length; k++) {
                        formFieldList[i].childFormFields[j].childFormFields[k].isEditable = true;
                        if (flag == 2) {
                            formFieldList[i].childFormFields[j].childFormFields[k].isEditable = false;
                        }
                        if (undefined != formFieldList[i].childFormFields[j].childFormFields[k].isVisible && !formFieldList[i].childFormFields[j].childFormFields[k].isVisible) {
                            continue;
                        }
                        var sonFieldId = formFieldList[i].childFormFields[j].childFormFields[k].fieldId;
                        if (nodePermissions[sonFieldId]) {
                            if (flag == 2) {
                                if (isTransactor) {
                                    formFieldList[i].childFormFields[j].childFormFields[k].isEditable = nodePermissions[sonFieldId].editable;
                                }
                            } else {
                                formFieldList[i].childFormFields[j].childFormFields[k].isEditable = nodePermissions[sonFieldId].editable;
                            }
                        }
                    }
                }
            }
        }
    }

    return formFieldList;
}
